import { Panel } from '../core/Panel';
import { Sim, ToolId } from '../../game/simulation';
import { ICON } from '../icons';

/**
 * Tool Rack panel — opens when the player clicks the world toolrack.
 * Lists the four manual tools (hoe / water / scythe / axe) as cards;
 * clicking one swaps state.tool to it (or back to 'hands' if it was
 * already held). Seeds live in their own SeedsPanel — the seed bag
 * stand opens that one separately.
 */
export class ToolRackPanel extends Panel {
  constructor(sim: Sim) { super(sim); }
  id() { return 'toolrack'; }
  title() { return 'Tool Rack'; }
  hashInputs() {
    return JSON.stringify({ tool: this.sim.state.tool });
  }
  body() {
    const current = this.sim.state.tool;
    const tools: { id: ToolId; name: string; icon: string; desc: string }[] = [
      { id: 'field',  name: 'Hoe',          icon: ICON.hoe,    desc: 'Hold to till a 3×3 of grass.' },
      { id: 'water',  name: 'Watering Can', icon: ICON.water,  desc: 'Hold + drag to water tilled tiles.' },
      { id: 'scythe', name: 'Scythe',       icon: ICON.scythe, desc: 'Hold to reap a 3×3 of mature crops.' },
      { id: 'axe',    name: 'Axe',          icon: ICON.axe,    desc: 'Strike to chop. Trees + boulders take 4 hits.' },
    ];
    const cards = tools.map(t => {
      const active = current === t.id;
      return `
        <div class="ui-card ${active ? 'active' : ''}" data-tool="${t.id}">
          <span class="ui-card__icon glyph">${t.icon}</span>
          <div>
            <div class="ui-card__title">${t.name}${active ? ' (held)' : ''}</div>
            <div class="ui-card__sub">${t.desc}</div>
          </div>
        </div>`;
    }).join('');
    return `
      ${cards}
      <div class="ui-tip">Pick a tool, or click again to put it back. Right-click anywhere drops the held tool.</div>
      <button class="ui-btn ui-btn--block" data-act="reposition">↔ Reposition this rack</button>
    `;
  }
  onClick(e: Event) {
    const t = e.target as HTMLElement;
    const act = (t.closest('[data-act]') as HTMLElement | null)?.dataset.act;
    if (act === 'reposition') {
      this.sim.startMoving('toolrack');
      this.hide();
      return;
    }
    const card = t.closest('[data-tool]') as HTMLElement | null;
    if (!card) return;
    const tool = card.dataset.tool as ToolId;
    this.sim.setTool(this.sim.state.tool === tool ? 'hands' : tool);
    this.hide();
  }
}
